export const shouldFetchStoreDetails = () => {
  const host = window.location.hostname;

  // ❌ blocked domains
  const blockedDomains = [
    "localhost",
    "127.0.0.1",
    "admin.axesell.com",
  ];

  // localhost check (covers localhost:3000 etc)
  if (host.includes("localhost") || host.includes("127.0.0.1")) {
    return false;
  }

  // exact match block
  if (blockedDomains.includes(host)) {
    return false;
  }

  return true;
};